import eventTaskService from "@/api/eventModule/eventTaskServices";

export default {
  loadTable({ commit }, pageConfig) {
    return new Promise((resolve, reject) =>
      eventTaskService
        .loadTable(pageConfig)
        .then((result) => {
          commit("LOAD_LIST_EVENT_TASKS", result.data.content);
          resolve(result);
        })
        .catch((err) => reject(err))
    );
  },
  insertNew({ commit }, data) {
    return eventTaskService
      .insertNew(data)
      .then((result) => result)
      .catch((error) => error);
  },
  prepareToEdit({ commit }, data) {
    commit("PREPARE_TO_EDIT_EVENT_TASK", data);
  },
  edit({ commit }, data) {
    return eventTaskService
      .edit(data)
      .then((result) => result)
      .catch((error) => error);
  },
  reset({ commit }) {
    commit("RESET_EVENT_TASK");
  },
  delete({ commit }, id) {
    return eventTaskService
      .delete(id)
      .then((result) => result)
      .catch((error) => error);
  },
};
